import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import saveSettings from '../utils/saveSettings';
import Form from '../../common/components/Form';
export default class SettingsModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "settings", {});
    _defineProperty(this, "loading", false);
  }
  form() {
    return null;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, this.form(), m("div", {
      className: "Form-group"
    }, this.submitButton())));
  }
  submitButton() {
    return m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading,
      disabled: !this.changed()
    }, app.translator.trans('core.admin.settings.submit_button'));
  }
  setting(key, fallback) {
    if (fallback === void 0) {
      fallback = '';
    }
    this.settings[key] = this.settings[key] || Stream(app.data.settings[key] || fallback);
    return this.settings[key];
  }
  dirty() {
    const dirty = {};
    Object.keys(this.settings).forEach(key => {
      const value = this.settings[key]();
      if (value !== app.data.settings[key]) {
        dirty[key] = value;
      }
    });
    return dirty;
  }
  changed() {
    return Object.keys(this.dirty()).length;
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    saveSettings(this.dirty()).then(this.onsaved.bind(this), this.loaded.bind(this));
  }
  onsaved() {
    this.hide();
  }
}
flarum.reg.add('core', 'admin/components/SettingsModal', SettingsModal);